<mat-card>
  <mat-card-content class="p-0">
    <app-datatable
      [configurationInput]="datatableConfigurations"
      [rowData]="formattedDatatableRows()"
      [columns]="(datatableColumns$ | async) ?? [{ id: 'id' }]"
      [total]="this.store.dataTotal$()"
      [customColumnDef]="[
        { name: 'status', template: itemStatusCell, isSortable: false },
        { name: 'title', template: titleCell, isSortable: true, isIncludedForBigDataStyle: true },
        { name: 'itemKey', template: itemKeyCell, isSortable: true },
        { name: 'assignee', template: assigneeCell, isSortable: true },
        { name: 'reporter', template: reporterCell, isSortable: true },
        { name: 'dueDate', template: dueDateCell, isSortable: true },
        { name: 'workInstruction', template: workInstructionCell, isSortable: false },
        { name: 'priority', template: priorityCell, isSortable: true },
      ]"
      (deleteClick)="selectedDatatableItems().length >= 2 ? initializeBulkDelete() : initializeDelete()"
      (editClick)="initializeEdit()"
      (addClick)="initializeAdd()"
      (dataRefreshRequest)="datatableParams$.next($event)"
      (selectedItemsChange)="selectedDatatableItems.set($event)"
    >
      <app-items-view-controls datatableToolbar></app-items-view-controls>
    </app-datatable>
  </mat-card-content>
</mat-card>

<ng-template #itemStatusCell let-row="row">
  <app-inline-item-status-chip
    class="inline-item-status"
    [currentWorkflowStepId]="row.currentWorkflowStepId"
    [boardItemConfigurationId]="row.boardItemConfiguration.id"
    [itemId]="row.id"
    (loadItem)="itemsService.triggerRefresh()"
  >
    <app-status-category-badge [statusCategory]="row.statusCategory" [label]="row.status"></app-status-category-badge>
  </app-inline-item-status-chip>
</ng-template>

<ng-template #assigneeCell let-row="row">
  <app-inline-user-chip
    [name]="row.assignee"
    [itemId]="row.id"
    [boardId]="row.boardId"
    (triggerRefresh)="itemsService.triggerRefresh()"
  >
    <app-user-chip [name]="row.assignee"></app-user-chip>
  </app-inline-user-chip>
</ng-template>

<ng-template #titleCell let-row="row">
  <div class="link-button" (click)="initializeEdit(row.id)">
    <mat-icon *ngIf="row.titleIcon" [ngClass]="row.titleIcon.class"> {{ row.titleIcon.icon }}</mat-icon>
    {{ row.title }}
  </div>
</ng-template>

<ng-template #workInstructionCell let-row="row">
  <button
    *ngIf="row.assignedWorkInstructions && row.assignedWorkInstructions?.length > 0"
    (click)="openWorkInstructions(row)"
    mat-mini-fab
    class="v-middle"
    type="button"
    matTooltip="{{ 'workInstructionStepper.button.startWorkInstruction' | translate }}"
  >
    <mat-icon>{{ row.assignedWorkInstructions?.length === 1 ? 'play_circle_outline' : 'menu_book' }}</mat-icon>
  </button>
</ng-template>

<ng-template #priorityCell let-row="row">
  <app-inline-item-priority [itemId]="row.id" [priority]="row.priority" (triggerRefresh)="itemsService.triggerRefresh()">
    <app-item-priority
      *ngIf="row.priority; else emptyPriority"
      [priority]="row.priority"
      [showLabel]="true"
      [hasTooltip]="false"
    ></app-item-priority>
    <ng-template #emptyPriority>
      <a class="empty-clickable-area">&nbsp;</a>
    </ng-template>
  </app-inline-item-priority>
</ng-template>

<ng-template #itemKeyCell let-row="row">
  <div class="link-button" (click)="initializeEdit(row.id)">{{ row.itemKey }}</div>
</ng-template>

<ng-template #reporterCell let-row="row">
  <app-inline-user-chip
    [name]="row.reporter"
    [itemId]="row.id"
    [boardId]="row.boardId"
    field="reporter"
    (triggerRefresh)="itemsService.triggerRefresh()"
  >
    <app-user-chip [name]="row.reporter"></app-user-chip>
  </app-inline-user-chip>
</ng-template>

<ng-template #dueDateCell let-row="row" let-i="index">
  <app-inline-date-picker [itemId]="row?.id" [date]="row?.dueDate?.original" (triggerRefresh)="itemsService.triggerRefresh()">
    <ng-container *ngIf="row?.dueDate?.original; else emptyClickable">
      <app-due-date-chip
        [doIgnoreDueDateCalculation]="row.statusCategory === 'done'"
        [dueDate]="row.dueDate"
        [strikeCount]="row.strikeCount"
      ></app-due-date-chip>
    </ng-container>
    <ng-template #emptyClickable>
      <a class="empty-clickable-area">&nbsp;</a>
    </ng-template>
  </app-inline-date-picker>
</ng-template>
